module.exports = __webpack_public_path__ + "img/1.873c084d.jpg";